import { useSearchParams } from "react-router-dom";

const useQueryParams = () => {
  const [searchParams] = useSearchParams();
  const showId = searchParams.get("showId") ?? "";
  const companyId = searchParams.get("companyId") ?? "";
  const email = searchParams.get("email")?.replace(/ /g, "+");
  return { showId, email, companyId };
};
export default useQueryParams;
